export enum ChartDateFormat {
  DayOfWeekMonthShortDayYear = '%A, %b %e, %Y',
}
